export default __webpack_public_path__ + "static/media/01.d7414bfe.jpg";